import api from './api'

export default class BaseService {
  static getAspsps (country) {
    return api.get(`/aspsps?country=${country}`)
  }

  static initiatePayment (country, aspspName, amount, message, redirect_url) {
    return api.post('/payments', {
      aspsp: {
        country: country,
        name: aspspName
      },
      psu_type: 'personal',
      redirect_url: redirect_url,
      state: 'random',
      payment: {
        credit_transfer_transaction: [{
          instructed_amount: amount,
          remittance_information: [message]
        }]
      }
    })
  }

  static getPayment () {
    return api.get('/payments/current')
  }

  static confirmPayment (url) {
    return api.put('/payments/current', {
      confirmation: {
        code: url
      }
    })
  }
}
